import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import VueQuillEditor from "vue-quill-editor"; //引入富文本编译器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import './assets/iconfont/iconfont.css';
import http from "./utils/http.js";
import VueCookie from "vue-cookie";
import utils from "@/utils/utils";
import * as eCharts from "echarts";
const hls = require("videojs-contrib-hls");

const isDebug_mode = process.env.NODE_ENV === "development";
Vue.config.debug = isDebug_mode;
Vue.config.devtools = isDebug_mode;
Vue.config.productionTip = isDebug_mode;
Vue.use(ElementUI);
Vue.use(VideoPlayer);
Vue.use(VueQuillEditor);
Vue.use(VueCookie);
Vue.use(hls);
Vue.prototype.$http = http;
Vue.prototype.$utils = utils;
Vue.prototype.$eCharts = eCharts;

Array.prototype.indexOfObj = function (key, val) {
  let i = -1;
  for (let [index, value] of this.entries()) {
    if (value[key] === val) {
      i = index;
      break;
    }
  }
  return i;
};
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
};

Array.prototype.indexOfObj = function (key, val) {
  let i = -1;
  for (let [index, value] of this.entries()) {
    if (value[key] === val) {
      i = index;
      break;
    }
  }
  return i;
};

Vue.prototype.validForbid = function (value, number = 255) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, "").replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`,
    });
  }
  return value;
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
